export const formatter = {
  remainingCouponDays: (days: number) => {
    const daysLegend = days === 1 ? 'dia' : 'dias';
    return days === 0 ? 'Expira hoje' : `Expira em ${days} ${daysLegend}`;
  },
  points: (value: number) => {
    return value.toLocaleString('pt-BR');
  },
};
